import React, { createContext, useContext, useState, useCallback } from 'react';

const GlobalErrorContext = createContext();

export const useGlobalError = () => {
    const context = useContext(GlobalErrorContext);
    if (!context) {
        throw new Error('useGlobalError must be used within a GlobalErrorProvider');
    }
    return context;
};

export const GlobalErrorProvider = ({ children }) => {
    const [error, setError] = useState(null);

    const showError = useCallback((title, message, code = null) => {
        setError({ title, message, code });
    }, []);

    const clearError = useCallback(() => {
        setError(null);
    }, []);

    return (
        <GlobalErrorContext.Provider value={{ error, showError, clearError }}>
            {children}
        </GlobalErrorContext.Provider>
    );
};
